export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '追溯宝云平台',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  // staticServer: 'http://iots.kerunsoft.cn',
  // staticServer: 'http://192.168.1.107:8085/upload/',
  staticServer: 'http://192.168.3.30:8199/upload',
  // staticServer: 'http://39.101.218.153:8085/upload',
  defaultAvatar: '/static/images/default_user.png',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://localhost:8081/fts',
    // pro: 'http://localhost:8081/fts'
    // dev: 'http://localhost:8081/fts',
    // pro: 'http://192.168.3.30:8081/fts'
    dev: 'http://www.zhuisubao.cn:8081/fts',
    pro: 'http://www.zhuisubao.cn:8081/fts'
  },
  // 百度地图密钥
  baiduAK: 'mvVPIKXhE1VTNEAQEro5ajWbn74lMfeO',
  // 验证码地址
  // vCodeUrl: 'http://localhost:8081/fts/core/sys/verify-code/generate',
  // webSocket: 'ws://localhost:8081/fts/websocket/',
  // vCodeUrl: 'http://localhost:8081/fts/core/sys/verify-code/generate',
  // webSocket: 'ws://192.168.3.30:8081/fts/websocket/',
  vCodeUrl: 'http://www.zhuisubao.cn:8081/fts/core/sys/verify-code/generate',
  webSocket: 'ws://www.zhuisubao.cn:8081/fts/websocket/',
  // 是否开启注册功能
  isRegFun: true,
  /**
   * @description 开发者模式, 如果是, 则加载样例页面及控件说明
   */
  developerMode: false,
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  brandHomeName: 'brand-home',
  /**
   * @description 默认租户认证页面, 如果该租户没有认证需要进入该页面
   */
  verbPage: 'tenant-cert',
  otherPlugin: {
    earlyWarning: false, // 设为false后不会在顶部显示预警标识
    fullscreen: false // 设为false后不会在顶部显示全屏
  },
  // homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: false, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js